export const HAS_SEEN_COMPLIMENTARY_NIGHT_PROMOTION_MODAL_KEY =
  "HAS_SEEN_COMPLIMENTARY_NIGHT_PROMOTION_MODAL_KEY ";
